module.exports = __webpack_public_path__ + "img/france-stomach-cancer-male.c7258ff4.png";